<ng-container *ngIf="twoFactorAuthService.checking2Foption; else promptModal">
  <p class="text-center pt-3 pb-3 h2">Please Wait...<span class="fa fa-spinner fa-pulse fa-fw"></span></p>
</ng-container>
<ng-template #promptModal>
<div class="container-fluid white-space-wrap text-left pt-2" [attr.data-qa]="'two-factor-prompt-modal'">
  <div class="row mt-4" *ngIf="twoFactorAuthService.serviceFail; else nonErrorBlock">
    <div class="col-xs-11 p-0 ml-3 mr-3" [attr.data-qa]="'two-factor-prompt-modal-error'" [attr.tabindex]="0" id="errorDiv" #errorDiv>
        <div class="alert alert-danger">
            <h3 class="h4">Error:</h3>
            <p> {{twoFactorAuthService.serviceFail || 'There is an error processing your request at this time. Please try again later.'}}</p>
        </div>
      </div>
  </div>
  <ng-template #nonErrorBlock>
    <h2 class="msg-title" [attr.data-qa]="'two-factor-prompt-modal-title'">{{promptModalTitle || "Two-Step Verification Required" }}</h2>
    <p class="pt-3 msg-body" [attr.data-qa]="'two-factor-prompt-modal-msg'">{{ promptModalMsg || "Your account is protected with Two-Step Verification. To proceed, please select Continue
      to request a verification code
      be sent to your" }}
      <ng-container *ngIf="payloadData && payloadData.contact">
      <span *ngIf="payloadData.contact.type === 'PHONE'"> phone number.</span>
      <span *ngIf="payloadData.contact.type === 'EMAIL'"> email address.</span></ng-container>
    </p>
  <div class="row">
    <div class="col-xs-12 text-right pt-2">
      <button type="button" class="btn btn-default" [attr.data-qa]="'two-factor-prompt-modal-close'" (click)="close()" data-dismiss="modal">Cancel</button>
      <button type="button" class="btn btn-primary ml-2" [attr.data-qa]="'two-factor-prompt-modal-continue'" (click)="continueToNavigate()">Continue
        <span class="sr-only"> to enter verification code screen</span>
      </button>
    </div>
  </div>
</ng-template>
</div>
</ng-template>

